export const toCapitalCase = (str: string) => {
    return [...str.replace(/_/g, ' ').toLowerCase()]
        .map((char, index) => index === 0 ? char.toUpperCase() : char)
        .join('');
};
